import { isEmpty } from 'lodash-es';
import axios from 'axios';

/*import {store} from '@/store/pastimes';*/
class SharedApi {
    constructor(debug) {
        this._debug  = debug  ?? false;
        this._checkWebShareApi = null;
    }

    async uploadFile(url, name, file, retry = false, videoStreamUrl = null) {
        let fd = new FormData();
        fd.append("file", file, name);
        try {
            const response = await axios.post(url, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log('url response: ', response);
            let status = response?.status ?? 500;
            if((status == 0 || status == 500) && !retry){
                return await this.uploadFile(url, name, file, true, videoStreamUrl);
            }
            //File already for cloudflare uploaded (409 is conflit) 
            if(status == 409 && (url.includes('imagedelivery') || url.includes('videodelivery'))){
                return url.replace('upload.','') + '/public';
            }
            
            if(status == 200 && videoStreamUrl) {
                return videoStreamUrl;
            }
            
            return response?.data?.result?.variants?.shift() ?? null;
        } catch (e) {
            this.logError('error file upload, ' + e);
        }
        return null;
    }

    async uploadFileArray(urlData, filesData, videoUpload = false) {
        this.debug('URL ARRAY DATA: ', urlData);
        this.debug('FILES ARRAY DATA: ', filesData);
        if (isEmpty(urlData) || isEmpty(filesData)) {
            return [];
        }
        let cloudFlareUrls = [];
        await Promise.all(urlData.map(async (element, index) => {
            try {
                let file   = filesData?.[index];
                if(file){
                    let mediaUrl = await this.uploadFile(element.uploadUrl, element.name, filesData[index], false, videoUpload ? element.videoId : null);
                   /* if(element.thumbnail) {
                        store.dispatch('registrationPage/setBlockThumbnail', element.thumbnail)
                    }*/
                    if (!mediaUrl) {
                        this.logError('error in cdn upload');
                    } else {
                        cloudFlareUrls.push(mediaUrl);
                    }
                }
            } catch (error) {
                this.logError('error cdn upload: ' + error);
            }
        }));
        this.debug('final cloudFlareUrls : ', cloudFlareUrls);
        return cloudFlareUrls.length == urlData.length ? cloudFlareUrls : null;
    }

    debug(){
        if(this._debug){
            console.log([...arguments]);
        }
    }

    logError(message) {
        if (typeof Bugsnag !== 'undefined') {
            Bugsnag.notify('jsError', message, {}, 'error');
        }
        else {
            console.error(message);
        }
    }

    filterSearch(options, query) {
        if (!isEmpty(options)) {
            const asArray = Object.entries(options);
            const filtered = asArray.filter(([key, value]) => value.name.toLowerCase().includes(query.toLowerCase()));
            return Object.fromEntries(filtered);
        }
        
        return [];
    }

    checkWebShareApi() {
        return navigator.share;
    }
    isValidUrl(url){
        // validate URL
        const regex = '^(https?:\\/\\/)?' // validate protocol (optional)
            +'(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}'// validate domain name
            +'(\\/[-a-z\\d%_.~+]+)+' // validate path (required)
            +'(\\?[;&a-z\\d%_.~+=-]*)?' // validate query string (optional)
            +'(\\#[-a-z\\d_]*)?$'; // validate fragment locator (optional)
        return !!(new RegExp(regex ,'i').test(url));
    }

    get checkWebShareApi() {
        if(this._checkWebShareApi == null){
            this._checkWebShareApi = typeof(navigator.share) == "function";
        }
        return this._checkWebShareApi;
    }
}

const sharedApiFn = function(){
    const url = window.location.href;
    const regexDev = /prozis\.[a-z]+.test/g;
    const regexSer = /store\.[a-z]+\.prozis\.tech/g;
    const foundDev = url.match(regexDev);
    const foundSer = url.match(regexSer);
    const debug = (foundDev?.length ?? 0) > 0 || (foundSer?.length ?? 0) > 0;
    return new SharedApi(debug);
}

export default sharedApiFn();